// extracted by mini-css-extract-plugin
module.exports = {"content":"DialogSurface_content_BLoXc"};